import client from "./client";

export const acceptOffer = (sessionId: string, clientId: string) =>
  client.post(
    `/client/${clientId}/session/${sessionId}/offer/accept`,
    {},
    {
      headers: { session_id: sessionId },
    }
  );
